export const eManagement = {
  groups: '/group/page',
  users: '/user/page',
  roles: '/role/',
  deleteUser: '/user/', // DELETE /user/{user_id}
  recoverUser: '/user/recover_user/', // POST /user/recover_user/{user_id}
  updateUserGroup: '/user/user_group_name/', // PUT /user/user_group_name/{user_id} body: {user_group_name}
  updateUserRole: '/user/user_role/', // PUT /user/user_role/{user_id} body: {user_role}
  inviteUsers: '/user/invite', // POST /user/invite body: {email[], user_group_name, user_account_type}
  getDnsOptions: '/scan_configs/all', // GET /scan_configs/dns_config
  deleteDnsOption: '/scan_configs/', // DELETE /scan_configs/{id}
  createDnsOption: '/scan_configs/dns_config/', // POST /scan_configs body: {dns_config}
  packages: '/packages', // GET list, POST create
  package: '/packages/' // PUT /packages/{key}, DELETE /packages/{key}
}
